export class CustomBookmarks {
  constructor(app) {
    this.app = app
    this.toolbarButtonElement = document.getElementById('customBookmarks')
    this.bookmarks = []
    this.activeClass = 'toggled'

    this._bindEvents()
  }

  _bindEvents () {
    this.toolbarButtonElement.addEventListener('click', (evt) => this._onClick(evt))
    this.app.eventBus.on('pagechanging', (evt) => this._onPageChanging(evt))
    this.app.eventBus.on('documentloaded', (evt) => this._onDocumentLoaded(evt))
    this.app.eventBus.on('openBookmark', (evt) => this._onBookmarkOpen(evt))
    this.app.eventBus.on('deleteBookmark', (evt) => this._onBookmarkDelete(evt))
  }

  _updateActiveState () {
    if (this.bookmarks.includes(this.app.page)) {
      this.toolbarButtonElement.classList.add(this.activeClass)
    } else {
      this.toolbarButtonElement.classList.remove(this.activeClass)
    }
  }

  _onClick () {
    if (this.bookmarks.includes(this.app.page)) {
      this.deleteBookmark(this.app.page)
      if (this.app.api.operating()) {
        this.app.api.deleteBookmark(this.app.page)
      }
    } else {
      this.addBookmark(this.app.page)
      if (this.app.api.operating()) {
        this.app.api.addBookmark(this.app.page)
      }
    }

    this._updateActiveState()
  }

  _onBookmarkOpen(evt) {
    this.app.page = evt.handle
  }

  _onBookmarkDelete(evt) {
    this.deleteBookmark(evt.handle)
    if (this.app.api.operating()) {
      this.app.api.deleteBookmark(evt.handle)
    }
  }

  _onPageChanging () {
    this._updateActiveState()
  }

  _onDocumentLoaded () {
    this.bookmarks = []
    this._updateActiveState()

    if (this.app.api.operating()) {
      this.toolbarButtonElement.classList.remove('hidden')
      this.app.api.getBookmarks()
        .then(bookmarks => {
          bookmarks.forEach(bookmark => {
            this.addBookmark(bookmark.page)
          })
        })
        .catch(err => console.error('Failed to load bookmarks', err))
    }
  }

  addBookmark(page) {
    this.bookmarks.push(page)
    this.app.secondaryToolbar.addBookmark(page, `${page}. oldal`)
    this._updateActiveState()
  }

  deleteBookmark(page) {
    this.bookmarks.splice(this.bookmarks.indexOf(page), 1)
    this.app.secondaryToolbar.deleteBookmark(page)
    this._updateActiveState()
  }
}

